import React from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";

const OfferCard = ({ offer, isExpanded, onExpand }) => {
  const [params] = useSearchParams();
  const handleClick = () => {
    setUserClickData({
      event_name: `offer-apply-button-for-no-press-alliance-lead-${offer.lender_name}`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    });
    setUserClickData({
      event_name: `offer-apply-button-for-no-press-alliance-lead`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    });

    window.location.href = `${offer.app_url}`;
  };

  const isLNT = offer.lender_id === "662752eb65fdba1a48d6e482";
  const horizontalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_hl || offer.logo_image_url;

  const verticalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_vl || offer.logo_image_url;

  return (
    <div className="offer-card-section1">
      <div
        className={`offer-card1 ${isExpanded ? "expanded1" : "collapsed1"}`}
        onClick={onExpand}
      >
        {isExpanded && (
          <>
            <img
              src={horizontalLogo}
              className="lender-logo"
              alt={offer.lender_name || "lender"}
            />
          </>
        )}

        <div className="offer-details">
          {isExpanded && <hr className="offer-divider" />}

          {isExpanded ? (
            <>
              <div className="amount-row">
                <span className="amount-label1">
                  {[
                    "662752eb65fdba1a48d6e466",
                    "666ec1953a9a969d8f9980f1",
                    "67762d497ae263a3ec86347e",
                    "6799b8fada60414f0f195bf9",
                    "67bd3abe694463207380f33d",
                    "67be8fc6049b9a4e3af8191a",
                    "67e23d6fe162ba8f717ec5bf",
                    "67ef646df80610d286084e60",
                    "68401febe871a7a9504dc2e3",
                  ].includes(offer.lender_id)
                    ? "Max Loan Amount:"
                    : "Pre-Approved Amount:"}
                </span>
                <span className="amount-value1">
                   {" "}upto ₹{offer.credit_limit}
                </span>
              </div>
            </>
          ) : (
            <div className="amount-row">
              <img src={verticalLogo} className="lender-logo" alt="Lender" />
              <div>
                <span className="amount-label1">
                {"Max Loan Amount: "}
                </span>
                <br />
                <span className="amount-value1">
                   {" "}upto ₹{offer.credit_limit}
                </span>
              </div>
            </div>
          )}

          {isExpanded && <hr className="offer-divider" />}

          {isExpanded && (
            <>
              {/* {!offer.isdefault && ( */}
              <>
                <div className="emi-row">
                  Tenure: {48 || offer.tenure} Months
                </div>
                {isExpanded && <hr className="offer-divider" />}
                {offer.interest_rate && (
                  <>
                    <span className="emi-row">
                      Interest Rate: {offer.interest_rate}
                    </span>
                  </>
                )}

                {isExpanded && <hr className="offer-divider" />}
                {offer.processing_fee && (
                  <div className="w-full text-center pb-2">
                    <span className="emi-row">
                      Processing Fees: {offer.processing_fee}
                    </span>
                  </div>
                )}
              </>
              {/* )} */}
              {isExpanded && offer.processing_fee && (
                <hr className="offer-divider" />
              )}

              <div className="loan-extra-details mt-3 text-sm text-gray-700">
                {offer.apr && (
                  <div className="flex justify-between mb-1 font-semibold">
                    <span className="font-semibold text-gray-800">APR:</span>
                    <span>{offer.apr}</span>
                  </div>
                )}

                {offer.penal_charges && (
                  <div className="flex justify-between mb-1 font-semibold">
                    <span className="font-semibold text-gray-800">
                      Penal Charges:
                    </span>
                    <span>{offer.penal_charges}</span>
                  </div>
                )}

                {offer.kfs_doc && (
                  <div className="flex items-center justify-between mt-2 font-semibold">
                    <span className=" text-gray-800 font-semibold">
                      View KFS:
                    </span>
                    <a
                      href={offer.kfs_doc}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-green-700 font-semibold hover:underline"
                    >
                      <FileText className="w-4 h-4 mr-1" />
                      Document
                    </a>
                  </div>
                )}
              </div>

              <button
                className="get-offer-btn tracking-get-offer-btn-v5"
                // id={`btn-get-offer-${
                //   offer.lender_name?.toLowerCase().replace(/\s+/g, "-") ||
                //   "unknown"
                // }-v5`}
                id={`btn-get-offer-v5`}
                onClick={handleClick}
              >
                {" "}
                Get Offer{" "}
                <img
                  src="/assets/img/Get offer CTA icon.svg"
                  alt="Arrow"
                  className="cta-icon"
                />
              </button>
            </>
          )}
        </div>

        {!isExpanded && (
          <img
            src="/assets/img/arrowOffer.png"
            className="collapse-arrow1"
            alt="Expand"
          />
        )}
      </div>
    </div>
  );
};

export default OfferCard;
